import { useState, useEffect } from "react";
import { Box, Chip } from "@mui/material";
import PercentOutlined from "@mui/icons-material/PercentOutlined";
import PriceChangeOutlined from "@mui/icons-material/PriceChangeOutlined";
import { MerchantCard, Loading, Error, EmptyState, PageHeader } from "../components";
import { getRates } from "../utils/api";
import { useMainStore } from "../store/store";

type Rate = {
  payment_method: string;
  operation_type: string;
  currency: string;
  rate: number;
  merchant_id: number;
  minsum: number;
  maxsum: number;
};

const Merchants: React.FC = () => {
  const [data, setData] = useState<Rate[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { curr } = useMainStore();

  useEffect(() => {
    setLoading(true);
    getRates()
      .then((res) => setData(res.data ?? []))
      .catch((err) => {
        setError("Error occured!");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <Loading variant="cards" />;
  }

  if (error) {
    return <Error error={error} />;
  }

  const forCurrency = data.filter(
    (el) => el.currency.toLowerCase() === curr.toLowerCase(),
  );

  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: "25px",
        maxHeight: {
          xs: "calc(var(--content-max-height) + 32.5dvh)",
          md: "82vh",
        },
        overflow: "auto",
      }}
    >
      <Box sx={{ width: "96%", margin: "0 auto", pb: 3 }}>
        <PageHeader
          title="Rates"
          description="Your commission per payment method and amount range"
          icon={PercentOutlined}
          actions={
            <Chip
              label={`${forCurrency.length} rates · ${curr}`}
              sx={{ height: 42, px: 1, fontWeight: 700 }}
            />
          }
        />

        {forCurrency.length > 0 ? (
          <MerchantCard rates={data} />
        ) : (
          <EmptyState
            icon={PriceChangeOutlined}
            title={`No rates for ${curr}`}
            description="Switch the currency in the header or contact your manager to have rates configured for this currency."
          />
        )}
      </Box>
    </Box>
  );
};

export default Merchants;
